// extracted by mini-css-extract-plugin
export default {"modalStyle":"chatbot_modalStyle__5n+ye","inputStyle":"chatbot_inputStyle__kOnXe","chatStyle":"chatbot_chatStyle__dAQkp","messageStyle":"chatbot_messageStyle__4+IC2"};